import { useMediaQuery, useTheme } from '@mui/material';
import InsuranceHeader from 'layouts/layout-parts/InsuranceHeader';
import ReportCreatorHeader from 'layouts/layout-parts/ReportCreatorHeader';
import CallmetellmeHeader from 'layouts/layout-parts/callmetellmeHeader';
import Footer from 'page-sections/dashboards/learning-management/Footer';
import { Fragment, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router'; // Import useLocation hook
import CRMHeader from '../layout-parts/CRMheader';
import CourseUploadHeader from '../layout-parts/CourseUploadHeader';
import DashboardHeader from '../layout-parts/DashboardHeader';
import DashboardSidebar from './DashboardSidebar';

const NaverLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation(); // Get the current location

  const [showSideBar, setShowSideBar] = useState(false);
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.key]);

  const isInsurance = location.pathname.startsWith('/naver/insurance');
  const isCallmetellme =
    location.pathname.startsWith('/naver/callmetellme') ||
    location.pathname.startsWith('/naver/partners');
  const isReportCreator = location.pathname.startsWith('/naver/report-creator');
  const isCourseUpload = location.pathname.startsWith('/naver/course-upload');
  const isCRM = location.pathname.startsWith('/naver/crm');

  const hideFooter =
    location.pathname === '/naver/wrtn' ||
    location.pathname === '/naver/wrtn2' ||
    location.pathname.startsWith('/naver/wrtn-chat') ||
    location.pathname === '/naver/namecard' ||
    location.pathname.startsWith('/naver/community') ||
    isInsurance ||
    location.pathname.startsWith('/naver/insurance-chat') ||
    location.pathname.startsWith('/naver/main-ai') ||
    location.pathname.startsWith('/naver/callmetellme') ||
    isReportCreator;

  const hideHeader =
    location.pathname === '/naver/namecard' ||
    location.pathname === '/naver/wrtn2' ||
    location.pathname.startsWith('/naver/wrtn-chat');

  const alwaysshowSideBar = location.pathname === '/naver/forumlist';

  return (
    <Fragment>
      <DashboardSidebar
        showSideBar={alwaysshowSideBar || showSideBar}
        setShowSideBar={() => setShowSideBar(state => !state)}
        showMobileSideBar={showMobileSideBar}
        closeMobileSideBar={() => setShowMobileSideBar(false)}
      />

      {!hideHeader &&
        (isInsurance ? (
          <InsuranceHeader />
        ) : isReportCreator ? (
          <ReportCreatorHeader />
        ) : isCallmetellme ? (
          <CallmetellmeHeader />
        ) : isCourseUpload ? (
          <CourseUploadHeader />
        ) : isCRM ? (
          <CRMHeader />
        ) : (
          <DashboardHeader
            setShowSideBar={() => setShowSideBar(state => !state)}
            setShowMobileSideBar={() => setShowMobileSideBar(state => !state)}
          />
        ))}

      {hideFooter ? (
        children || <Outlet />
      ) : (
        <Fragment>
          {children || <Outlet />}
          <Footer showSideBar={showSideBar} />
        </Fragment>
      )}
    </Fragment>
  );
};

export default NaverLayout;
